import { render } from "./IdentityVerification.vue?vue&type=template&id=56594a18&scoped=true"
import script from "./IdentityVerification.vue?vue&type=script&lang=js"
export * from "./IdentityVerification.vue?vue&type=script&lang=js"

import "./IdentityVerification.vue?vue&type=style&index=0&id=56594a18&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56594a18"]])

export default __exports__